import { h, Component } from 'preact';

import style from './style.less';

import { configure } from '../../../config';
import { getLastGamePlayed } from '../../../lib/game';

import { Icon } from '@cube/blocks';
import cx from 'classnames';
import {  trackProps, DIMENSION } from '@cube/track';


/** Creates promo for a game based on last game played or random suggestion
 */
@configure({
	gamePromotion: 'singleCube.gamePromotion'
})
export class GamePromotion extends Component {
	

	getRandomInt(max) {
		return Math.floor(Math.random() * max);
	}

	componentWillMount() {
		// Get from local storage first
		let game = getLastGamePlayed();

		if (!game) {
			//build it from config
			game = this.props.gamePromotion.games[this.getRandomInt(this.props.gamePromotion.games.length)];
			game.display = this.props.gamePromotion.text[this.getRandomInt(this.props.gamePromotion.text.length)] + ' : ' + game.title;
		}
		else {
			game.display = 'Play Again : ' + game.title;
		}

		this.setState({ game });
	}

	render({ p25, variant, moreLink, isWideScreen }, { game }) {
		if (!game) return;

		if (p25) {
			return (
				<span>

					<div class={cx(style.gamePromotion, style.gamePromotionP25, style[variant], isWideScreen && style.gamePromotionP25Wide)}>
						<a href={`/games/play/canonical/${game.id}/vendor/Arkadium`}>
							<div>
								<Icon name="games-wire-cube" />
							</div>
							<div class={style.display}>
								{game.display}
							</div>
						</a>
					</div>
					{isWideScreen &&
					<div class={style.moreGames}>
						<a
							href={moreLink}
							target="_blank"
							rel="noopener noreferrer"
							{...trackProps(
								{
									[DIMENSION.componentpath]: 'moreGames'
								},
								this.context
							)}
						>
							<span class={style.moreGamesText}>
								More Games
							</span>
							<span class={style.moreGamesIcon}>
								<Icon name="navigate-right-cube" />
							</span>
						</a>
					</div>}
				</span>
			);
		}

		return (
			<div class={cx(style.gamePromotion,style[variant])}>
				<a href={`/games/play/canonical/${game.id}/vendor/Arkadium`}>
					<div>
						<Icon name="games-wire-cube" />
					</div>
					<div class={style.display}>
						{game.display}
					</div>
					<div>
						<Icon class="navigateNext" name="navigate-right-cube" />
					</div>
				</a>
			</div>
		);
	}
}
